import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
export function TreatmentAreasSection() {
  const {
    t
  } = useLanguage();
  const areas = [{
    title: t('treatment.nasolabial'),
    description: t('treatment.nasolabialDesc'),
    points: ['Immediate volume restoration', 'Natural facial expressions', 'Lasts up to 12 months']
  }, {
    title: t('treatment.lips'),
    description: t('treatment.lipsDesc'),
    points: ['Soft, natural feel', "Enhanced cupid's bow", 'Reduced perioral lines']
  }, {
    title: t('treatment.cheeks'),
    description: t('treatment.cheeksDesc'),
    points: ['High lifting capacity', 'Restores youthful triangle', 'Lasts up to 18 months']
  }, {
    title: t('treatment.jawline'),
    description: t('treatment.jawlineDesc'),
    points: ['Sharpens facial contours', 'Improves facial harmony', 'Non-surgical alternative']
  }];
  return <section id="treatment-areas" className="py-24 bg-white" data-id="element-742">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-743">
        <div data-id="element-744">
          {/* Content */}
          <div data-id="element-745">
            <h2 className="text-sm font-bold tracking-widest text-brand-copper uppercase mb-3" data-id="element-746">
              {t('treatment.label')}
            </h2>
            <h3 className="text-3xl md:text-4xl font-light text-gray-900 mb-6 leading-tight" data-id="element-747">
              {t('treatment.title1')}{' '}
              <span className="font-semibold" data-id="element-748">{t('treatment.title2')}</span>
            </h3>
            <p className="text-gray-600 mb-10 leading-relaxed" data-id="element-749">
              {t('treatment.subtitle')}
            </p>

            <div className="space-y-8" data-id="element-750">
              {areas.map((area, index) => <div key={index} className="flex" data-id="element-751">
                  <div className="flex-shrink-0 mt-1" data-id="element-752">
                    <div className="w-8 h-8 rounded-full bg-brand-lightCopper/50 flex items-center justify-center text-brand-darkCopper font-semibold text-sm" data-id="element-753">
                      0{index + 1}
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-754">
                    <h4 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-755">
                      {area.title}
                    </h4>
                    <p className="text-gray-600 text-sm mb-3" data-id="element-756">
                      {area.description}
                    </p>
                    <ul className="flex flex-wrap gap-2" data-id="element-757">
                      {area.points.map((point, idx) => <li key={idx} className="text-xs font-medium bg-gray-100 text-gray-600 px-2 py-1 rounded" data-id="element-758">
                          {point}
                        </li>)}
                    </ul>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}